/**
 * Application configuration
 * Centralizes all environment-dependent settings
 */

// Smart API URL configuration
const isProd = process.env.NODE_ENV === 'production';
const isTest = process.env.NODE_ENV === 'test';
const raw = process.env.REACT_APP_API_URL;

// In production: default to same-origin (empty string means "same origin")
// In dev: if not set, fall back to localhost:5000 (your proxy)
const API_BASE = raw && raw.trim().length
  ? raw.trim()
  : (isProd ? '' : 'http://localhost:5000');

// Optional: keep a gentle dev-only warning
if (!raw && !isProd && !isTest) {
  // eslint-disable-next-line no-console
  console.warn('REACT_APP_API_URL not set; using http://localhost:5000 in dev.');
}

const config = {
  // API Configuration
  api: {
    baseUrl: API_BASE,
    timeout: 10000,
  },

  // Environment
  env: process.env.NODE_ENV || 'development',
  isDevelopment: process.env.NODE_ENV === 'development',
  isProduction: process.env.NODE_ENV === 'production',

  // OAuth Configuration
  auth: {
    googleLoginUrl: `${API_BASE}/auth/google`,
    callbackUrl: '/auth/callback',
  },

  // Feature Flags
  features: {
    enableAnalytics: process.env.REACT_APP_ENABLE_ANALYTICS === 'true',
    enableDebugMode: process.env.REACT_APP_DEBUG === 'true',
  },
};

// Production validation removed - now using same-origin requests

export default config;